/**
 * FleetManager V3 - Dashboard Tabs Component
 * Browser-style tabs for dashboard navigation
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap, Activity } from 'lucide-react';

export const TABS = [
  { id: 'actions', labelKey: 'dashboard.tabs.actions', icon: Zap },
  { id: 'suivi', labelKey: 'dashboard.tabs.monitoring', icon: Activity }
];

/**
 * @param {Array} [tabs] - les onglets à montrer ; par défaut, tous.
 *
 * Un seul onglet ne se dessine PAS : une barre d'onglets à un onglet est un
 * décor qui promet un ailleurs inexistant (retrait de « Suivi » pour le
 * conducteur, JGS 2026-09-14). Le choix de la liste appartient à l'appelant,
 * qui seul connaît le profil.
 */
export function DashboardTabs({ activeTab, onTabChange, tabs = TABS }) {
  const { t } = useTranslation();
  if (!tabs || tabs.length < 2) return null;
  return (
    <div className="flex items-end gap-0.5 px-4 pt-2">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              relative flex items-center gap-2 px-4 py-2.5 rounded-t-lg transition-all
              ${isActive
                ? 'bg-white text-gray-900 z-10 border border-gray-200 border-b-white'
                : 'bg-gray-50 text-gray-500 hover:text-gray-700 hover:bg-gray-100'
              }
            `}
          >
            <Icon size={14} className={isActive ? 'text-blue-500' : ''} />
            <span className="text-sm font-medium">{t(tab.labelKey)}</span>
          </button>
        );
      })}

      {/* Fill remaining space with border */}
      <div className="flex-1 border-b border-gray-200" />
    </div>
  );
}

export default DashboardTabs;
